import { render, staticRenderFns } from "./premiseList.vue?vue&type=template&id=74eb058e&"
import script from "./premiseList.vue?vue&type=script&lang=js&"
export * from "./premiseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74eb058e')) {
      api.createRecord('74eb058e', component.options)
    } else {
      api.reload('74eb058e', component.options)
    }
    module.hot.accept("./premiseList.vue?vue&type=template&id=74eb058e&", function () {
      api.rerender('74eb058e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/views/green/premiseList.vue"
export default component.exports